import './animations/onload-animations';
import './animations/inview-animations';
import './animations/scroll-animations';
import './animations/projects-animations';
